export default __webpack_public_path__ + "5a4c8667d65d4cd918d7dd19a8f45e92.svg";